import React, { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";

export const Input = ({
	onChange,
	value,
	disabled,
	placeholder,
	multiline,
	rows,
	minRows,
	maxRows,
	required,
	inputType,
	fullWidth,
	classes,
	autoFocus,
	color,
	sx,
}) => {
	return (
		<TextField
			value={value}
			onChange={onChange}
			disabled={disabled}
			placeholder={placeholder}
			multiline={multiline}
			rows={rows}
			minRows={minRows}
			maxRows={maxRows}
			required={required}
			type={inputType}
			fullWidth={fullWidth}
			classes={classes}
			autoFocus={autoFocus}
			color={color}
			sx={sx}
		/>
	);
};
